// material-ui
import logo from 'src/assets/images/agra-pehra.png';

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //
import { useSelector } from "react-redux";
const LogoMain = ({ reverse, ...others }: { reverse?: boolean }) => {

 const organizationLogo = useSelector((state: any) => state.userprofile.organization_logo)

  return <img src={organizationLogo ? `data:image/png;base64,${organizationLogo}`:"" } alt="Sail-Logo" width="100" />;
};

export default LogoMain;
